// extracted by mini-css-extract-plugin
export default {"container":"document-image_container__2uqQH","icon":"document-image_icon__9Db7S","typeIcon":"document-image_typeIcon__2nVqC","brandIcon":"document-image_brandIcon__Ua3yM"};